import { computedAsync } from '@vueuse/core';
import type { PossiblyAsyncIntegration } from './types/asyncIntegration';
import type { IntegrationsStore } from './types/integrationsStore';
import { useIntegration } from './useIntegration';

export const useInstallations = <Integrations extends Record<string, PossiblyAsyncIntegration>>(
  store: IntegrationsStore<Integrations>,
) => {
  return {
    installations: computedAsync(() => {
      Object.values(store.installations).forEach((installation) => {
        useIntegration(installation.integration.code, store);
      });

      return Object.values(store.installations);
    }, []),
  };
};
